/* unplugin-vue-components disabled */import script from "./LineAreaConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./LineAreaConfig.vue?vue&type=script&setup=true&lang=js"

import "./LineAreaConfig.vue?vue&type=style&index=0&id=659101d2&lang=css"

const __exports__ = script;

export default __exports__